import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6145b3bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-3xl my-2 border-b-2 pl-2 border-gray-400 dark:border-dark-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["problem-select-wrapper max-w-screen-lg box-border px-12 py-8 m-4 overflow-y-scroll text-gray-800 dark:text-dark-text", { 'custom-scrollbar': _ctx.isLightMode(), 'custom-scrollbar-dark': !_ctx.isLightMode() }]),
        style: {"user-select":"none"}
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.note_jp, (note, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "pt-2 mb-10"
          }, [
            _createElementVNode("h1", _hoisted_1, _toDisplayString(note.title) + ": ", 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.description, (des, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "description ml-12 text-lg"
                }, _toDisplayString(des), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ], 2)
    ]),
    _: 1
  }))
}